import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter, useParams } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'antd/dist/reset.css';
import './index.css';
import './App.css';
import App from './App';
import Store from './store';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { requestPermission } from './config/firebase/notification';
// import { ErrorBoundary } from 'react-error-boundary';

// function ErrorFallback({ error, resetErrorBoundary }) {
//     return (
//         <div
//             role="alert"
//             style={{
//                 padding: '50px',
//                 textAlign: 'center',
//                 backgroundColor: '#f8d7da',
//                 color: '#721c24',
//                 height: '100vh',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//             }}
//         >
//             <h1>Something went wrong</h1>
//             <pre
//                 style={{
//                     margin: '20px 0',
//                     border: '1px solid currentColor',
//                     padding: '10px',
//                 }}
//             >
//                 {error.message}
//             </pre>
//             <button
//                 onClick={resetErrorBoundary}
//                 style={{
//                     padding: '10px 20px',
//                     backgroundColor: '#721c24',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: 'pointer',
//                 }}
//             >
//                 Try again
//             </button>
//         </div>
//     );
// }

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

// registration of a service worker.
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/firebase-messaging-sw.js')
            .then((registration) => {
                console.log(
                    'Service Worker registered with scope:',
                    registration.scope,
                );
                return registration;
            })
            .then((registration) => {
                if (!localStorage.getItem('fcmToken')) {
                    requestPermission(registration)
                        .then(() => {
                            return;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            })
            .catch((err) => {
                console.error('Service Worker registration failed:', err);
            });
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASE_NAME || '/'}>
        <QueryClientProvider client={queryClient}>
            <Provider store={Store}>
                <DndProvider backend={HTML5Backend}>
                    {/* <ErrorBoundary
                        fallbackRender={ErrorFallback}
                        onReset={() => window.location.reload()}
                    > */}
                    <App />
                    {/* </ErrorBoundary> */}
                </DndProvider>
            </Provider>
        </QueryClientProvider>
    </BrowserRouter>,
    // </React.StrictMode>
);

reportWebVitals();
